(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon/assets/javascripts/coupon.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon/assets/javascripts/coupon.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useContext = _React.useContext,
  useState = _React.useState;
const DrawContext = svs.components.tipsen.drawProvider.DrawContext;
const useCurrentDraw = svs.components.tipsen.drawProvider.hooks.useCurrentDraw;
const useIsCurrentDrawPlayable = svs.components.tipsen.hooks.useIsCurrentDrawPlayable;
const _svs$components$tipse = svs.components.tipsen.coupon,
  CouponRow = _svs$components$tipse.CouponRow,
  CouponSingleRows = _svs$components$tipse.CouponSingleRows;
const useObserveSettings = svs.components.tipsen.coupon.hooks.useObserveSettings;
const useCouponId = svs.components.tipsen.couponId.useCouponId;
const selectNumberOfBoards = svs.components.tipsen.engine.selectors.couponSelectors.selectNumberOfBoards;
const selectShowMatchAnalysesInCoupon = svs.components.tipsen.selectors.selectShowMatchAnalysesInCoupon;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_AM = _svs$components$lbUti.BREAKPOINT_AM;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const Paper = svs.ui.ReactPaper;
const Button = svs.ui.ReactButton;
const ScrollableButtonGroup = svs.components.tipsen.scrollableButtonGroup.ScrollableButtonGroup;
const containerSelector = '.coupon-singels-mobile-boards';
const FetchDrawAnalysesByHook = svs.components.tipsen.hooks.FetchDrawAnalysesByHook;
const LABELS_1X2 = svs.components.sport.tipsenShared.constants.LABELS_1X2;
const Coupon = () => {
  const couponId = useCouponId();
  const draw = useCurrentDraw();
  const boardSize = useSelector(state => selectNumberOfBoards(state, couponId));
  const isDrawPlayable = useIsCurrentDrawPlayable();
  const _useContext = useContext(DrawContext),
    eventNumber = _useContext.eventNumber;
  const _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    selectedBoard = _useState2[0],
    setSelectedBoard = _useState2[1];
  const isSingelRows = boardSize > 1;
  const mappedBoards = [];
  for (let i = 0; i < boardSize; i++) {
    mappedBoards.push(i);
  }
  const showMatchAnalysesInCoupon = useSelector(selectShowMatchAnalysesInCoupon);
  const shouldFetchMatchAnalyses = !showMatchAnalysesInCoupon.hideAll;
  const outcomeLabels = LABELS_1X2;
  useObserveSettings();
  const renderCoupon = () => isSingelRows ? React.createElement(CouponSingleRows, {
    couponId: couponId,
    events: draw.drawEvents,
    hasDisabledBets: !isDrawPlayable,
    outcomeLabels: outcomeLabels,
    selectedBoard: selectedBoard
  }) : React.createElement("ol", {
    className: "coupon-rows",
    "data-testid": "standard-coupon"
  }, draw.drawEvents.map((drawEvent, index) => React.createElement(CouponRow, {
    board: 0,
    couponId: couponId,
    event: index,
    hasDisabledBets: !isDrawPlayable,
    isSelected: drawEvent.eventNumber === eventNumber,
    key: drawEvent.eventNumber,
    outcomeLabels: outcomeLabels
  })));
  return React.createElement(React.Fragment, null, useMediaQuery(breakpoints.down(BREAKPOINT_AM)) && isSingelRows && React.createElement("div", {
    className: "coupon-singels-mobile-boards",
    role: "radiogroup"
  }, React.createElement(ScrollableButtonGroup, {
    containerSelector: containerSelector
  }, mappedBoards.map(board => React.createElement(Button, {
    "aria-checked": selectedBoard === mappedBoards.indexOf(board),
    className: "coupon-singels-mobile-boards-button"
    ,
    key: board,
    onClick: () => setSelectedBoard(mappedBoards.indexOf(board))
  }, React.createElement("span", null, selectedBoard === mappedBoards.indexOf(board) ? "Rad ".concat(board + 1) : board + 1))))), React.createElement(Paper, {
    "aria-label": "Kupong",
    branding: "sport",
    className: "coupon",
    Component: "section"
  }, shouldFetchMatchAnalyses && React.createElement(FetchDrawAnalysesByHook, {
    drawNumber: draw.drawNumber,
    productId: draw.productId
  }), renderCoupon()));
};
setGlobal('svs.components.tipsen.coupon.Coupon', Coupon);

 })(window);